import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Warning from "../../../assets/kinologyIcons/svg/warningForgot.svg";
import { FinancialActions } from "../../../store/ducks/financial";
import {ReactComponent as Close} from "../../../assets/kinologyIcons/svg/close.svg";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);

const ModalMelhorMomento: React.FC = () => {
	const dispatch = useDispatch();
	const classes = useStyles();

	const current_language = useSelector(
		(state: any) => state.configs.current_language
	);

	const is_open_modal_melhor_momento = useSelector(
		(state: any) => state.financial.modal_melhor_momento
	);
	const payment_type: 'bank_slip' | 'pix' | 'card' | null = useSelector((state: any) => state.financial.payment_type);
	
	const handleClose = () => {
		dispatch(FinancialActions.set_modal_melhor_momento(false));
		
	};

	const handleSelectOption = (option: number) => {
			dispatch(FinancialActions.set_request_add_user_in_white_list(option))
		handleClose();
	};

	const oneDayPromess = 1
	const TwoDayPromess = 2
	const sevenDayPromess = 7
	const alreadyPay = 10

	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			className={classes.modal}
			open={is_open_modal_melhor_momento}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<Fade in={is_open_modal_melhor_momento}>
				<ModalContainer>
					<ModalContent>
						<CloseButton onClick={()=>{
							handleClose()
							if(payment_type === 'bank_slip'){
								dispatch(FinancialActions.set_modal_boleto(true))
							}
						}}>
							<Close width={18} height={18} style={{right:5, top:10,  position: 'absolute'}}/>
						</CloseButton>
						<IconContainer>
							<img style={{ width: "4rem", height: "4rem" }} src={Warning} />
						</IconContainer>
						<Title>{current_language?.nao_identificamos_pagamento}</Title>
						<Title>{current_language?.melhor_momento_pagamento}</Title>
						<Button onClick={() => handleSelectOption(oneDayPromess)}>
							{current_language?.hoje}
						</Button>
						<Button onClick={() => handleSelectOption(TwoDayPromess)}>
							{current_language?.amanha}
						</Button>
						<Button onClick={() => handleSelectOption(sevenDayPromess)}>
							{current_language?.em_ate_7_dias}
						</Button>
					</ModalContent>
				</ModalContainer>
			</Fade>
		</Modal>
	);
};

const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
`;

const ModalContent = styled.div`
	background: white;
	padding: 20px;
	border-radius: 0.75rem;
	max-width: 25%;
	width: 100%;
	text-align: center;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	position: relative;
`;

const CloseButton = styled.button`
	position: absolute;
	top: 10px;
	right: 10px;
	background: none;
	border: none;
	font-size: 30px;
	cursor: pointer;
`;

const IconContainer = styled.div`
	margin-bottom: 16px;
	margin-top: 16px;
`;

const Title = styled.h2`
	font-size: 16px;
	color: #002060;
	margin: 0 0 16px;
`;

const Button = styled.button`
	width: 100%;
	padding: 12px;
	font-size: 14px;
	font-weight: bold;
	color: #009973;
	background-color: white;
	border: 1px solid #009973;
	border-radius: 0.75rem;
	margin-bottom: 8px;
	cursor: pointer;
	&:hover {
		background-color: #f6f6f6;
	}
`;

export default ModalMelhorMomento;
